import {
  Box,
  Button,
  CssBaseline,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import NavbarComponent from "../component/navbar-component";
import DeleteIcon from "@mui/icons-material/Delete";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import axios from "axios";
import Swal from "sweetalert2";

const boxVariant = {
  visible: { opacity: 1, scale: 1, transition: { duration: 0.5 } },
  hidden: { opacity: 0, scale: 1 },
};

const BoxAnimate = ({ component }) => {
  // State definition
  const control = useAnimation();
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      control.start("visible");
    } else {
      control.start("hidden");
    }
  }, [control, inView]);

  return (
    <motion.div
      className="box"
      ref={ref}
      variants={boxVariant}
      initial="hidden"
      animate={control}
    >
      {component}
    </motion.div>
  );
};

const gabungkanPesanan = (orders) => {
  const map = {};
  let totalQty = 0;

  orders.forEach((item) => {
    const key = Object.keys(item)[0];
    const data = item[key];

    // ✅ Ambil SEMUA varian
    const varians = data.order_detail
      .filter(d => d.varian_id)
      .map(d => ({
        varian_id: d.varian_id,
        type: d.type
      }))
      .sort((a, b) => a.varian_id.localeCompare(b.varian_id));

    const addons = data.order_detail
      .filter(d => d.addon_id)
      .map(d => ({
        addon_id: d.addon_id,
        qty: d.max_addon || 1
      }))
      .sort((a, b) => a.addon_id.localeCompare(b.addon_id));

    const signature = JSON.stringify({
      product_name: data.product_name,
      brand: data.brand,
      varians,
      addons
    });

    if (!map[signature]) {
      map[signature] = {
        ...data,
        qty: data.qty || 1,
        varians,
        addons
      };
    } else {
      map[signature].qty += data.qty || 1;
    }

    totalQty += data.qty || 1;
  });

  return {
    items: Object.values(map)
      .sort((a, b) => {
        if (a.product_name !== b.product_name) {
          return a.product_name.localeCompare(b.product_name);
        }

        if (a.brand !== b.brand) {
          return a.brand.localeCompare(b.brand);
        }

        return JSON.stringify(a.varians)
          .localeCompare(JSON.stringify(b.varians));
      })
      .map((data, i) => ({
        [`merged-${i}`]: data
      })),

    totalQty
  };
};

const FormReviewPage = () => {
  const navigate = useNavigate();
  const location = useLocation();  
  const [orders, setOrders] = useState([]);
  const [totalItem, setTotalItem] = useState(null);
  const [bio, setBio] = useState({
    order_date: dayjs().format("DD-MM-YYYY"),
    order_person: "[order_person]",
    outletId: "[outletid]",
    phone: "[phone]",
    seat: "4",
    pack: "25",
    address: "[address]",
    type: "[type]"
  });
  const [rBio, setRBio] = useState({});
  const [outlets, setOutlets] = useState([]);

  const deleteItem = (payload) => {
    const { tmp_id } = payload;

    let pOrders = JSON.parse(localStorage.getItem("orders")) || [];

    let nArr = pOrders.filter((ob) => {
      const sku = Object.keys(ob)[0];
      return ob[sku].tmp_id !== tmp_id;
    });

    setOrders(nArr);
    localStorage.setItem("orders", JSON.stringify(nArr));
  };

  const createWAObj = (bio) => {
    const isCatering = bio["Reservation Type"] === "catering";

    let py = `Hello Saya Ingin Reservasi ${bio["Reservation Type"]}, berikut data dan pesanan saya :\n
    Nama: ${bio["Nama"]}
    Kontak: ${bio["Kontak"]}    
    Tanggal Reservasi: ${dayjs(rBio["order_date"]).format("DD-MM-YYYY HH:mm")}
    ${isCatering ? "Pack" : "Seat"}: ${
        isCatering ? bio["Pack"] : bio["Seat"]
      }
    ${isCatering ? "Address" : "Outlet"}: ${
        isCatering ? bio["Address"] : bio["Outlet"]
      }
    Link Pesanan : https://reservasi.kabita.id/invoice?o=${encodeURIComponent(
        location.state
      )}
    `;

    return py;
  };

  // ==== Use Effect Function ====
  const proceed = () => {
    let fM = orders.filter((ele) => {
      let k = Object.keys(ele)[0];
      return ele[k]?.category !== "minuman";
    });    

    const totalQty = fM.reduce((accu, ele) => {
      let k = Object.keys(ele)[0];
      return accu + (ele[k]?.qty || 0);
    }, 0);

    const limitQty =
      bio["Reservation Type"] === "catering"
        ? bio["Pack"]
        : bio["Seat"];        

    const limitLabel = bio["Reservation Type"] === "catering" ? "pack" : "seat";

    if (limitQty <= totalQty) {
      Swal.fire({
        title: "Pesanan Sudah Benar ?",
        showDenyButton: true,
        confirmButtonText: "Ya Pesan",
        denyButtonText: `Cek Lagi`,
      }).then((result) => {
        if (result.isConfirmed) {
          const { outletId, ...cleanBio } = rBio;
          let values = {
            // bio: rBio,
            // orders: orders,
            // order_id: location.state,
            ...cleanBio,
            order_id: location.state,
            outlet_id: rBio.outletId,
            order_details: JSON.stringify(orders),
          };                     
              
          axios({
            method: "post",            
            url: `https://script.google.com/macros/s/AKfycbwMR-2Dk9gpd5_KlmhL1Lgk_opPU6OOzb-KJQjizlRtYpKtX_Bp7QWa4i172CDKoRbE/exec?api=order`,
            headers: {
              "Content-Type": "text/plain"
            },
            // data: values, 
            data: JSON.stringify(values)                                  
          })
            .then((resp) => {
              if (resp) {
                let wa_payload = createWAObj(bio, bio["Reservation Type"]);
                let waPayload_encoded = encodeURIComponent(wa_payload);

                Swal.fire({
                  title: `Terimakasih Sudah Reservasi ${String.fromCodePoint(
                    0x1f64f
                  )}`,
                  html: `<small> Konfirmasi ke admin kami untuk proses selanjutnya.<small>`,
                }).then((r) => {
                  if (r) {
                    window.open(
                      `https://wa.me/+62882002670116?text=${waPayload_encoded}`
                    );
                  }
                });

                localStorage.removeItem("reservationData");
                localStorage.removeItem("orders");
                navigate("/reservasi");
              } else {
                Swal.fire("Mohon Maaf", "Ada Kesalahan", "error");
              }
            })
            .catch(() => {
              Swal.fire("Mohon Maaf", "Ada Kesalahan", "error");
            });
        }
      });
    } else {
      Swal.fire({
        title: `Mohon Maaf ${String.fromCodePoint(0x1f64f)}`,
        html: `<small> Jumlah makanan, harus sama atau lebih dari ${limitLabel} yang dipesan <small>`,
        showDenyButton: false,
        confirmButtonText: "Tambah Pesanan",
      });
    }
  };
  
  useEffect(() => {   
    // Get data Outlet
    axios({
      method: "get",
      url: `https://script.google.com/macros/s/AKfycbwMR-2Dk9gpd5_KlmhL1Lgk_opPU6OOzb-KJQjizlRtYpKtX_Bp7QWa4i172CDKoRbE/exec?api=outlet`,     
    })    
      .then((response) => {
        const rawData = response.data;
        setOutlets(rawData.data);    

        let sReservation = JSON.parse(localStorage.getItem("reservationData"));
        // setOrders(JSON.parse(localStorage.getItem("orders")));
        const rawOrders = JSON.parse(localStorage.getItem("orders")) || [];
        const { items, totalQty } = gabungkanPesanan(rawOrders);
        setOrders(items);
        setTotalItem(totalQty);

        let sOutlet = rawData.data.filter((ele) => {
          return parseInt(ele.outlet_id) === parseInt(sReservation.outletId);
        });
  
        setBio({
          "Reservation Type": sReservation.type,
          Nama: sReservation.order_person,
          Kontak: `${sReservation.phone}`,          
          ...(sReservation.type === "catering"
            ? {
                "Tanggal Pengiriman": dayjs(sReservation.order_date).format(
                  "DD-MM-YYYY HH:mm"
                ),
                Pack: sReservation.pack,
                Address: sReservation.address,
              }
            : {
                "Tanggal Reservasi": dayjs(sReservation.order_date).format(
                  "DD-MM-YYYY HH:mm"
                ),
                Seat: sReservation.seat,
                Outlet: `${sOutlet[0]?.outlet} - ${sOutlet[0]?.address}`,
          }),          
        });

        setRBio(sReservation);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);   

  return (
    <div className="body">
      <CssBaseline />
      <BoxAnimate component={<NavbarComponent />} />

      <Grid container justifyContent="center" py={2}>
        <Grid item xs={11} sm={9} md={7} lg={4}>
          <Paper
            elevation={6}
            sx={{
              mx: "auto",
              p: 2,
              borderRadius: 3,
              background: "linear-gradient(180deg, #ffffff 0%, #f9fafb 100%)",
            }}
          >
            {/* Header */}
            <Box textAlign="center" mb={2}>
              <Typography variant="h6" fontWeight={800} color="success.main">
                Kabita Group
              </Typography>
              <Typography fontSize=".8em" color="text.secondary">
                Invoice / Ringkasan Pesanan
              </Typography>

              <Divider sx={{ my: 1 }} />

              <Typography fontSize=".75em" color="text.secondary">
                Order ID
              </Typography>
              <Typography fontWeight={700}>{location.state}</Typography>
            </Box>

            {/* Data Pemesan */}
            <Box mb={2}>
              <Typography fontWeight={700} mb={1}>
                Data Pemesan
              </Typography>

              {Object.keys(bio).map((d) => (
                <Grid
                  container
                  key={d}
                  spacing={1}
                  alignItems="center"
                  mb={0.5}
                >
                  <Grid item xs={4}>
                    <Typography fontSize=".85em">{d}</Typography>
                  </Grid>

                  <Grid item xs={8}>
                    <Typography
                      fontWeight={600}
                      textAlign="right"
                      fontSize=".85em"
                    >
                      {bio[d]}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </Box>

            <Divider sx={{ my: 2 }} />

            {/* Detail Pesanan */}
            <Box>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={1}
              >
                <Typography fontWeight={700}>Pesanan Anda</Typography>
                <Button size="small" onClick={() => navigate("/menu")}>
                  Tambah
                </Button>
              </Box>

              {orders.map((item) => {                
                const data = item[Object.keys(item)];                              

                return (
                  <Box key={Object.keys(item)} mb={1.5}>                
                    <Grid container spacing={1}>
                      <Grid item xs={8}>
                        <Typography fontWeight={700} fontSize=".9em">
                          {data.product_name}
                        </Typography>
                        <Typography fontSize=".75em" color="text.secondary" textTransform="uppercase">
                          {data.brand}
                        </Typography>                   

                        {/* List Varian & Addon */}
                        {data.order_detail
                          .filter((ele) => !ele.note && (ele.name || ele.addon_item))
                          .map((ele, i) => (
                            <Typography key={i} fontSize=".75em">                             
                              • {ele.name || ele.addon_item}
                                {(ele.type || ele.addon_type) &&
                                  ` (${ele.type || ele.addon_type})`}
                            </Typography>
                          ))}

                        {/* Catatan */}
                        {data.order_detail.find((ele) => ele.note) && (
                          <Box mt={1}>
                            <Typography fontSize=".75em" fontWeight={700}>
                              Catatan:
                            </Typography>                         
                            <Typography
                              fontSize=".75em"
                              sx={{
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                                overflowWrap: "anywhere",
                              }}
                            >
                              {data.order_detail.find((ele) => ele.note)?.note}
                            </Typography>
                          </Box>
                        )}
                      </Grid>
                      <Grid item xs={4}>
                        <Stack alignItems="flex-end" spacing={0.5}>                          
                          <IconButton size="small" onClick={() => deleteItem(data)}>
                            <DeleteIcon fontSize="small" color="error" />
                          </IconButton>
                          <Typography fontWeight={600}>x{data.qty}</Typography>
                          <Typography fontWeight={700}>
                            Rp {data.subtotal.toLocaleString("id-ID")}
                          </Typography>                          
                        </Stack>
                      </Grid>
                    </Grid>

                    <Divider sx={{ mt: 1 }} />
                  </Box>
                );
              })}
            </Box>

            {/* Total */}
            <Box display="flex" justifyContent="space-between">
              <Typography fontWeight={800} fontSize="1.05em">
                {/* TOTAL PEMEASANAN */}
              </Typography>
              <Typography fontWeight={800} fontSize="1em">
                ({totalItem} pesanan)
              </Typography>
            </Box>

            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mt={2}
            >
              <Typography fontWeight={800}>TOTAL</Typography>
              <Typography fontWeight={900} fontSize="1.1em" color="success.main">
                Rp{" "}
                {orders
                  .reduce(
                    (accu, ele) =>
                      accu +
                      ele[Object.keys(ele)].subtotal *
                        ele[Object.keys(ele)].qty,
                    0
                  )
                  .toLocaleString("id-ID")}
              </Typography>
            </Box>                        

            <Button
              fullWidth
              variant="contained"
              size="large"
              sx={{ borderRadius: 2, mt: 2 }}
              onClick={proceed}
            >
              Reservasi
            </Button>
          </Paper>
        </Grid>
      </Grid>      
    </div>
  );
};

export default FormReviewPage;
